import React,{useEffect} from 'react'
import classes from './AuthorizedSignatory.module.css'
import SubSectionHeader from '../../../Shared/SubSectionHeader'
import NoRecordFound from '../../../Shared/NoRecordFound'
import Input from '../../../Shared/Forms/Input'
import {useAppContext,ContextConstants} from '../../../../Context/AppContext'
import {
    replaceValueForKey,
    hasValue,
    isValidPhoneNumber,
    isValidEmail} from '../../../../Utility'
import PhoneInputWithCountrySelect from 'react-phone-number-input'
const AuthorizedSignatory = ({
    transporterInfo,
    isEditable,
    navigatigAway
}) => {
    const { dispatch } = useAppContext();
    const countryCode="+91"
    useEffect(() => {
        dispatch({
          type: ContextConstants.getAuthEmailValid,
          payload: isValid
        });
    }, []);
    
    const defaultCountry = localStorage.getItem("countryCode") || "IN";
      
    const EditMode = ({ transporterInfo ,navigatigAway}) => {
        const authSignatory = transporterInfo && transporterInfo.authSig_details;
        return (
            <>
            <div className={classes['flex-direction-row']+' '+classes['margin-top10px']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        Name:
                        </span>
                    <span className={classes['font-color']}>
                    <Input
                        onChange={value => {
                            replaceValueForKey(authSignatory, 'name', value);
                        }}
                        className={classes['input-box-height']}
                        defaultValue={authSignatory && authSignatory.name}
                    />
                    </span>
                </div>

                <div className={classes['flex-direction-row']+' '+classes['margin-top10px']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        Email:
                        </span>
                    <span className={classes['font-color']}>
                    <Input
                        onChange={value => {
                            replaceValueForKey(authSignatory, 'email', value);
                        }}
                        className={classes['input-box-height']}
                        defaultValue={authSignatory && authSignatory.email}
                        isInvalid={navigatigAway&& !isValidEmail(authSignatory.email)}
                        
                    />
                    </span>
                </div>

               
                <div className={classes['flex-direction-row']+' '+classes['margin-top10px']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        Phone Number:
                        </span>
                    <span className={classes['font-color']}>
                    {/* <Input
                        prefix={countryCode}
                        onChange={value => {
                            replaceValueForKey(authSignatory, 'phone', countryCode+value);
                        }}
                        className={classes['input-box-height']}
                        defaultValue={authSignatory.phone?
                            authSignatory.phone.replace('+91',''):
                            ''}
                        isInvalid={navigatigAway&& !isValidPhoneNumber(authSignatory.phone)}
                        maxLength={10}
                    /> */}
                    <PhoneInputWithCountrySelect
                        defaultCountry={defaultCountry}
                        international
                        value={authSignatory?.phone}
                        onChange={value => {
                            replaceValueForKey(authSignatory, 'phone', value);
                        }}
                        placeholder="Contact number"
                        numberInputProps={{
                            className : `form-input-phone-input border-left-0 border-right-0 border-top-0 border-bottom`
                        }}
                    />
                    </span>
                </div>
                <div className={classes['flex-direction-row']+' '+classes['margin-top10px']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        PAN Card Number:
                        </span>
                    <span className={classes['font-color']}>
                    <Input
                        maxLength={10}
                        onChange={value => {
                            replaceValueForKey(authSignatory, 'pan_number', value);
                        }}
                        className={classes['input-box-height']}
                        defaultValue={authSignatory && authSignatory.pan_number}
                    />
                    </span>
                </div>
            </>
        )
    }
    const ReadMode = ({ transporterInfo }) => {
        const authSignatory = transporterInfo && transporterInfo.authSig_details;
        return (
            <>
                <div className={classes['flex-direction-row']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        Name:
                        </span>
                    <span className={classes['font-color']}>
                        {authSignatory && authSignatory.name ? (
                            authSignatory.name
                        ) : (
                                <NoRecordFound message={'--'}></NoRecordFound>
                            )}
                    </span>
                </div>

                <div className={classes['flex-direction-row']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        Email:
                        </span>
                    <span className={classes['font-color']}>
                        {authSignatory && authSignatory.email ? (
                            authSignatory.email
                        ) : (
                                <NoRecordFound message={'--'}></NoRecordFound>
                            )}
                    </span>
                </div>

                <div className={classes['flex-direction-row']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        Phone Number:
                        </span>
                    <span className={classes['font-color']}>
                        {authSignatory && authSignatory.phone ? (
                            authSignatory.phone
                        ) : (
                                <NoRecordFound message={'--'}></NoRecordFound>
                            )}
                    </span>
                </div>
                
                <div className={classes['flex-direction-row']}>
                    <span
                        className={classes['field-label'] + ' ' + classes['font-color']}
                    >
                        PAN Card Number:
                        </span>
                    <span className={classes['font-color']}>
                        {authSignatory && authSignatory.pan_number ? (
                            authSignatory.pan_number
                        ) : (
                                <NoRecordFound message={'--'}></NoRecordFound>
                            )}
                    </span>
                </div>
            </>
        )
    }
    return (
        <div className={classes['width100Per']}>
            <SubSectionHeader title="Authorized Signatory Details"></SubSectionHeader>
            {isEditable ?
                <EditMode transporterInfo={transporterInfo} navigatigAway={navigatigAway} /> :
                <ReadMode transporterInfo={transporterInfo} />}

        </div>
    )
}
const isValid = transporterInfo => {
    let valid=true;
    if(hasValue(transporterInfo.authSig_details.email)){
    
    valid=valid&&isValidEmail(transporterInfo.authSig_details.email) 
    }
    // if(hasValue(transporterInfo.authSig_details.phone)){
    
    //     valid=valid&&isValidPhoneNumber(transporterInfo.authSig_details.phone) 
    //     }
    return valid;
  };


export default AuthorizedSignatory
